import { useLocation } from '@xing-com/crate-core-router';

export const useIsWebview = (): boolean => {
  const location = useLocation();

  const isWebview = location.pathname.startsWith('/pages/webview');

  return isWebview;
};
